import React from 'react'
import * as actions from '../actions/index'

const initialState = {
  open:false,
  saving:false,
  answered: [],
  gap: {
    view: ''
  },
  fill: {answer: '', value:[], privacy:'members'},
  vectoredQuestion: false,
  selectedVectorChoice: null
};

const appReducer = function(state = initialState, action) {

  if(action.type === actions.OPEN_HP) {
    return {...state, open: !state.open };
  }

  if(action.type === actions.UPDATE_FILL_VALUE) {
    return {...state, fill:{...state.fill, value:action.value} };
  }

  if(action.type === actions.UPDATE_FILL_ANSWER) {
    return {...state, fill:{...state.fill, answer:action.answer} };
  }

  if(action.type === actions.SKIP_GAP) {
    return {...state, fill:{...state.fill, value: 'SKIP_USER', answer: 'skipped'} };
  }

  if(action.type === actions.SORT_FILL_VALUE) {
    return {...state, fill:{...state.fill, value: state.fill.value.sort()} };
  }

  if(action.type === actions.SET_WEIGHT_DATA) {
    return {...state, fill:{...state.fill, weight: action.data} };
  }

  if(action.type === actions.RESET_FILL) {
    if(action.answer.title) {
      return {
        ...state, fill: {answer: '', value: [], privacy: 'members'},
        answered: [...state.answered, action.answer]};
    } else {
      return {...state, fill:{answer: '', value:[], privacy:'members'}};
    }
  }

  if(action.type === actions.DESTROY_VIEW) {
    return {...state, vectoredQuestion: false, selectedVectorChoice: null, gap: {...state.gap, view: 'undefined'}};
  }

  if(action.type === actions.REMOVE_GAP_FOR_EDIT) {
    return {...state, answered: [...action.filteredAnswers], gap: {...state.gap, view: 'undefined'}};
  }

  if(action.type === actions.ON_LOAD) {
    return {...state, answered: [...action.stowed.answered],
      vectoredQuestion: action.stowed.vectoredQuestion,
      selectedVectorChoice: action.stowed.selectedVectorChoice};
  }

  if(action.type === actions.GET_GAP_UPDATE) {
    var { data, vector_answers, ...gapResponse } = action.body.data
      if (vector_answers !== undefined) {
        state.vectoredQuestion = true;
        for (var key in vector_answers) {
          if (vector_answers[key] === null) {
            state.selectedVectorChoice = key;
            break;
          }
        }
        var gapTitleArray = data.title.split(/{{|}}/);
        gapTitleArray[1] = state.selectedVectorChoice;
        return {...state, gap: {...gapResponse, ...data, vector_answers, title: gapTitleArray.join('')}}
      } else {
        return {...state, gap: {...gapResponse, ...data}}
      }
  }

  if(action.type === actions.SET_GAP_UPDATE) {
    if (action.answeredQuestion.hasOwnProperty('vectorChoice')) {
      var { data, vector_answers, ...gapResponse } = action.body.data

      var gapTitleArray = data.title.split(/{{|}}/);
      gapTitleArray[1] = action.answeredQuestion.vectorChoice;
      return {...state,
        vectoredQuestion: true,
        selectedVectorChoice: action.answeredQuestion.vectorChoice,
        gap:{...gapResponse, ...data, vector_answers, title: gapTitleArray.join('')}};
    } else {
      var {data, ...gapResponse} = action.body.data
      return {...state, gap: {...gapResponse, ...data}};
    }
  }

  return state;
}

export default appReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js